<div class="display-box">
    <mat-icon class="close-icon" (click)="closeModal()">close</mat-icon>

    <h2 i18n  class="title">Before you can proceed</h2>
    <div class="description">
    <p><span i18n >You have warnings in your tree. <br />
    You can choose to accept this and proceed your order or view your warnings 
    </span>
    <span i18n class="view-warning" (click)="viewWarning()">here</span></p>
    </div>
    <section class="example-section">
        <mat-checkbox i18n class="ignore-warning" [(ngModel)]="ignore" >
            I accept all my warnings and I want to proceed to order
        </mat-checkbox>
    </section>
    <button i18n mat-raised-button [disabled]="!ignore"
        style="background-color: #B6C1B1; color: #470037; font-size: 20px; padding: 5px 20px; margin: 35px;"
        (click)="next()">NEXT</button>
</div>